import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/toaster';
import { HelmetProvider } from 'react-helmet-async';
import EpureLoader from './components/EpureLoader';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

import Index from './pages/Index';
import NotFound from './pages/NotFound';
import Diagnostic from './pages/Diagnostic';
import SystemeGlow from './pages/SystemeGlow';
import DiagnosticConfirmation from './pages/DiagnosticConfirmation';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // Safety net: force content visible after 5s no matter what
  useEffect(() => {
    const safety = setTimeout(() => setIsLoading(false), 5000);
    return () => clearTimeout(safety);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <Router>
          {isLoading && (
            <EpureLoader 
              onLoadingComplete={() => setIsLoading(false)}
              minDisplayTime={2000}
            />
          )}

          <div style={{ opacity: isLoading ? 0 : 1, transition: 'opacity 0.3s ease-in' }}>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/diagnostic" element={<Diagnostic />} />
                <Route path="/diagnostic/confirmation" element={<DiagnosticConfirmation />} />
                <Route path="/systeme-glow" element={<SystemeGlow />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ErrorBoundary>
          </div>
          <Toaster />
        </Router>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;
